module.exports = __webpack_public_path__ + "static/img/2.2bca7f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R141B/2.jpg
// module id = gbmU
// module chunks = 1